import React from 'react'
import classnames from 'classnames'
import { mapArrIndexed, flattenObj } from '../helpers'
import { ViewerContext } from '../context/ViewerContext.jsx'
import * as R from 'ramda'
import Drawer from './Drawer.jsx'
import '../polyfill.js'
import { sectionProps } from '../types'

class Section extends React.Component {
  static propTypes = sectionProps

  constructor(props) {
    super(props)
    this.section = React.createRef()
  }

  componentDidUpdate() {
    if (
      this.props.sectionContent.colorNotes.id ===
      this.context.state.highlightedSection
    ) {
      const section = this.section.current
      if (!section.classList.contains('visible')) {
        section.classList.add('visible')
      }
    }
  }

  renderButtonClass(sectionId, footnote, footnoteNum, currentView) {
    const key = currentView + '-' + sectionId
    return classnames('flyout-section__btn', {
      current: R.has(key, footnote) && footnote[key] === footnoteNum,
    })
  }
  createAnchors(sectionCopy, sectionId) {
    let newCopy = sectionCopy
    const splitCopy = R.reject(R.isEmpty, newCopy.split(/<sup>(.*?)<\/sup>/g))
    const currentFootnotes = this.props.currentFootnotes
    newCopy = splitCopy.map(x => {
      if (!isNaN(x) && splitCopy.length > 1) {
        //check if it's a number
        let num = x
        return (
          <sup className="flyout-section__sup" key={num}>
            <span
              aria-pressed="false"
              className={this.renderButtonClass(
                sectionId,
                currentFootnotes,
                num,
                this.props.currentView
              )}
              onClick={e =>
                this.props.updateFootnote(
                  e,
                  sectionId,
                  num,
                  this.props.currentView
                )
              }
              onKeyPress={e =>
                this.props.updateFootnote(
                  e,
                  sectionId,
                  num,
                  this.props.currentView
                )
              }
              role="button"
              tabIndex="0"
            >
              {num}
            </span>
          </sup>
        )
      } else {
        return <span key={x} dangerouslySetInnerHTML={{ __html: x }} />
      }
    })

    return newCopy
  }

  renderDrawer(relatedArt, translatorNotes, colorNotes, sectionId) {
    //since ids are now autogenerated, we're going to omit them from our empty check to make sure there aren't false positives
    const testArr = [R.omit(['sectionId'], relatedArt)]
    if (this.props.currentView === 'translation') {
      testArr.push(R.omit(['sectionId'], translatorNotes))
    }
    testArr.push(R.omit(['sectionId', 'id', 'coordinates'], colorNotes))
    const checkForEmpty = R.all(R.isEmpty, R.values(flattenObj(testArr)))
    if (!checkForEmpty) {
      return (
        <Drawer
          currentView={this.props.currentView}
          toggleDrawer={this.props.toggleDrawer}
          relatedArt={relatedArt}
          translatorNotes={translatorNotes}
          colorNotes={colorNotes}
          sectionId={sectionId}
          showAllFootnotes={this.props.showAllFootnotes}
          currentFootnotes={this.props.currentFootnotes}
          updateFootnote={this.props.updateFootnote}
        />
      )
    } else {
      return
    }
  }

  checkForOnClick = (highlightedSection, sectionId) => {
    if (highlightedSection === sectionId) {
      this.context.highlightSection('')
    }
  }

  render() {
    const sectionContent = this.props.sectionContent
    const colorNotes = sectionContent.colorNotes
    const currentView = this.props.currentView
    const currentFootnotes = this.props.currentFootnotes
    const highlightedSection = this.context.state.highlightedSection
    const sectionId = sectionContent.sectionId
    const relatedArt = R.map(x => x, sectionContent.relatedArt)
    const translatorNotes = R.map(x => x, sectionContent.translatorNotes)

    const relatedArtNum = mapArrIndexed((x, i) => {
      const comma = i < sectionContent.relatedArt.length - 1 ? ',' : null
      const anchor = sectionId + '-' + x.footNum
      return (
        <React.Fragment key={anchor}>
          <span
            aria-pressed="false"
            className={this.renderButtonClass(
              sectionId,
              currentFootnotes,
              x.footNum,
              currentView
            )}
            onClick={e =>
              this.props.updateFootnote(e, sectionId, x.footNum, currentView)
            }
            onKeyPress={e =>
              this.props.updateFootnote(
                e,
                sectionId,
                x.footNum,
                this.props.currentView
              )
            }
            role="button"
            tabIndex="0"
          >
            {x.footNum}
          </span>
          {comma}
        </React.Fragment>
      )
    }, sectionContent.relatedArt)
    const newContent = this.createAnchors(
      sectionContent[currentView],
      sectionId
    )
    const getHighlightClass = classnames(
      'flyout-section__copy',
      sectionId,
      'js-' + sectionId,
      {
        'flyout-section__copy--highlight': highlightedSection === sectionId,
      }
    )

    return (
      <React.Fragment>
        <div ref={this.section} className="flyout-section js-flyout-section">
          <div className="flyout-section__content">
            <div className="flyout-section__number">
              {sectionContent.sectionNum !== '0'
                ? sectionContent.sectionNum
                : ''}
              {relatedArtNum && (
                <sup className="flyout-section__sup">{relatedArtNum}</sup>
              )}
            </div>
            <div className={getHighlightClass}>
              <div
                className="flyout-section__text"
                onClick={() =>
                  this.checkForOnClick(highlightedSection, sectionId)
                }
              >
                {newContent}
              </div>
            </div>
          </div>
          {this.renderDrawer(
            relatedArt,
            translatorNotes,
            colorNotes,
            sectionId
          )}
        </div>
      </React.Fragment>
    )
  }
}
Section.contextType = ViewerContext
export default Section
